export const mainGrayColor: string = '#676767';
export const shades2Color: string = '#F3F2F0';
